import type { ImportMetaLocation } from "@-/dev.improve.haniverse.lib.logger";
import { createActorFindFirstQuery } from "#create-actor-find-first-query";
import { createActorFindManyQuery } from "#create-actor-find-many-query";
import type { ActorQueryTable } from "#types";

export function createActorTableQueries<TTable extends ActorQueryTable>(
  location: ImportMetaLocation,
  table: TTable,
) {
  return {
    findFirst: createActorFindFirstQuery(location, table),
    findMany: createActorFindManyQuery(location, table),
  };
}
